import {httpLikeRequestTroughWebsocket} from "@stores/serverConnection/makeApiServerRequest";


import {PM_ACTIONS} from "@stores/serverConnection/types";
import {userDeviceId} from "../../sync/UserDeviceId";
import {WsServerConnection} from "@stores/serverConnection/wsServerConnection";


export interface generateQuizWithAiParams {
    docId: string,
    count: number | string,
    requiredPassPercentage: number,
    docTitle?: string,
}

export const generateQuizWithAi = async (
    wsServerConnection: WsServerConnection,
    {
        docId,
        count,
        requiredPassPercentage,
        docTitle,
    }: generateQuizWithAiParams,
    abortController?: AbortController
) => {
    return await httpLikeRequestTroughWebsocket(
        wsServerConnection,
        `ai/quiz`,
        PM_ACTIONS.AI_QUIZ_CREATE,
        {
            docId: docId,
            count: count,
            requiredPassPercentage: requiredPassPercentage,
            docTitle: docTitle,
            ud: userDeviceId,
        },
        (msg) => `${msg.docId}`,
        abortController,
        60000
    );
}

